import DataTableRelationDto from "../../classes/dtos/pathcommonmodule/DataTableRelationDto";
import DataTableReadMapper from "./DataTableReadMapper";

export default class DataTableRelationMapper {

    static ToDto(e: any): DataTableRelationDto {
        return new DataTableRelationDto(e.id, DataTableReadMapper.ToDto(e.linkedTable)!, e.type, e.source);
    }

    static ToDtos(e: any[]): DataTableRelationDto[] {
        return e.map((e) => DataTableRelationMapper.ToDto(e));
    }

    static ToPayload(e: DataTableRelationDto): object {
        let result = {
            id: e.Id,
            LinkedTable: DataTableReadMapper.ToPayload(e.LinkedTable),
            Type: e.Type,
            Source: e.Source
        }
        return result;
    }

    static ToPayloads(e: DataTableRelationDto[]): object[] {
        return e.map((e) => this.ToPayload(e));
    }
}